import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import axios from "axios";
import { useAuthContext } from "../../context/AuthContext";
import { Box, FormControl, InputLabel, Select } from "@mui/material";

const SearchComponent = ({
  setData,
  setSelectedYear,
  selectedYear,
  handleSearch,
  afm,
  setAfm,
  afmError,
  setAfmError,
}) => {
  const { setLoading, setNotification } = useAuthContext();
  const [years, setYears] = useState([]);

  useEffect(() => {
    const getFilterArrays = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/newListOfYears`,
          {
            withCredentials: true,
          },
        );
        setYears(response.data.years);
      } catch (error) {
        console.error("Error fetching years:", error);
      } finally {
        setLoading(false);
      }
    };

    getFilterArrays();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: { sm: "no-wrap", xs: "wrap" },
        alignItems: "flex-start",
        flexDirection: "row",
        gap: "1em",
      }}
    >
      <FormControl required>
        <InputLabel id="demo-simple-select-label">Έτος</InputLabel>
        <Select
          label="Ετος"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          sx={{ minWidth: "130px" }}
        >
          {years.map((year, index) => (
            <MenuItem key={index} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        inputProps={{ maxLength: 9 }}
        required
        label="ΑΦΜ"
        value={afm}
        onChange={(e) => {
          setAfm(e.target.value.trim());
          if (e.target.value.trim() !== "") {
            if (e.target.value.trim().length !== 9) {
              setAfmError("Το ΑΦΜ πρέπει να είναι 9 χαρακτήρες!");
            } else {
              setAfmError("");
            }
          }
        }}
        error={!!afmError && afm.trim() !== ""}
        helperText={afm.trim() !== "" ? afmError : ""}
      />

      <Button
        disabled={afm?.length !== 9 || !!!selectedYear}
        variant="contained"
        onClick={handleSearch}
        sx={{ margin: "8px" }}
      >
        Αναζήτηση
      </Button>
    </Box>
  );
};

export default SearchComponent;
